/* eslint-disable */
export const getMessages = (locale: string) => {
    try {
        return (window as any)._newLocales.Status[locale];
    } catch (e) {
        // TODO: send errors to sentry or handle them somehow another way.
    }
    switch(locale) {
        case "ru_RU":
            return import("./compiled/ru_RU-Status.json").then(m => m.default);
        default: 
            return {};
    }
}

export const getSupportedLocales = (): string[] => [
    "ru_RU",
];
